module.exports = __webpack_public_path__ + "img/Group 134.2e5e58b0.svg";